import { combineReducers } from "redux";
import item from "./item";
import isFetching from "./isFetching";
import byId from "./byId";
import deleteErrors from "./deleteErrors";

export default combineReducers({ item, isFetching, byId, deleteErrors });



// WEBPACK FOOTER //
// ./src/reducers/accessLevel/index.js